import React, {Component} from 'react';
import {
    Card,
    Divider,
    Row,
    Col,
    Tooltip,
    Icon,
    Input,
    Form,
    DatePicker,
    Button,
    Collapse,
    Tag,
    Alert,
    Select
} from 'antd';
import * as moment from 'moment';
import Document from './Document';

const FormItem = Form.Item;
const Panel = Collapse.Panel;
const Option = Select.Option;

class EngineerForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            edit: false,
            showAlert: false,
            engineer: {}
        }
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.engineer.id !== prevState.engineer.id) {
            return {
                showAlert: false,
                engineer: nextProps.engineer
            };
        }
        return null;
    }
    handleSubmit(e){
        e.preventDefault();
        const {form, onUpdate} = this.props;
        return form.validateFieldsAndScroll((err, values) => {
            if (err) {
                return;
            }
            const dateFields = [
                'crb_expiry_date',
                'working_at_heights',
                'manual_handling',
                'asbestos_cat_b',
                'ppe'
            ];
            dateFields.forEach(field => {
                if (values[field]) {
                    values = {...values, [field]: values[field].format('DD/MM/YYYY')}
                }
            });
            return onUpdate(values).then(() => {
                const {engineer: {error}} = this.props;
                const state = {showAlert: true, edit: false};
                if (error) {
                    state.edit = true;
                }
                this.setState(state);
            });
        });
    }
    render() {
        const {engineer, form: {getFieldDecorator}, settings, onUpload, onDelete, generateUrl: gen, branches} = this.props;
        const required = (name) => settings.filter(s => s.name === name && s.config).length;
        const {edit, showAlert} = this.state;
        const {
            error,
            full_name,
            email,
            phone_number,
            documents
        } = engineer;
        const generateUrl = file => gen(engineer.id, file);
        const formatDate = (field, includeTime = false) => {
            const date = engineer[field] && engineer[field].date;
            if (!date) return '-';
            return moment(date, `YYYY-MM-DD ${includeTime ? 'H:mm:ss' : ''}`).format(`DD/MM/YYYY ${includeTime ? 'h:mm:ss a' : ''}`);
        };
        const toggleEdit = (e) => {
            e.preventDefault();
            this.setState({edit: !this.state.edit});
        };
        const title = () => (
            <div style={{lineHeight: '35px'}}>
                <span>{`${full_name}'s Profile`}</span>
                {!this.state.edit ? (
                    <Tooltip title="Edit Details">
                        <a href="#" onClick={toggleEdit}> <Icon type="edit"/></a>
                    </Tooltip>
                ) : null}
            </div>
        );

        const textField = (field, required = true) => {
            if (!edit) return engineer[field] || '-';

            return (
                <FormItem hasFeedback>
                    {getFieldDecorator(field, {
                        initialValue: engineer[field],
                        rules: [{ required, whitespace: true }],
                    })(
                        <Input size="small"/>
                    )}
                </FormItem>
            )
        };

        const selectField = (field, required = true) => {
            const val = engineer[field];
            if (!edit) {
                const branch = branches && branches.data.find(b => b.id === +val);
                return branch ? branch.branch_name : '-';
            }

            return (
                <FormItem hasFeedback>
                    {getFieldDecorator(field, {
                        initialValue: val ? val + '' : 'Select a branch location',
                        rules: [{ required}],
                    })(
                        <Select>
                            {branches.data.map(b => (
                                <Option value={b.id+''} key={b.id}>{b.branch_name} - {b.address_line_1} {b.main_office ? '(M)' : ''}</Option>
                            ))}
                        </Select>
                    )}
                </FormItem>
            )
        };

        const datePicker = (field, required = true) => {
            if (!edit) return formatDate(field);
            const date = engineer[field] && engineer[field].date;

            return (
                <FormItem hasFeedback>
                    {getFieldDecorator(field, {
                        initialValue: date ? moment(date, 'YYYY-MM-DD') : moment(),
                        rules: [{ type: 'object', required, whitespace: true }],
                    })(
                        <DatePicker size="small" format='DD/MM/YYYY'/>
                    )}
                </FormItem>
            );
        };

        const errorStr = error && Object.keys(error.res.errors).map(key => error.res.errors[key].map((e, i) => <span key={i}>{e}</span>));
        const color = field => {
            const date = engineer[field] && engineer[field].date;
            let color = '#52c41a';
            if (!date) return color;

            const diff = moment(date, 'YYYY-MM-DD').diff(moment(), 'days');
            if (diff < 0) {
                color = '#f5222d';
            } else if (diff < 30) {
                color = '#faad14'
            }
            return color;
        };
        const dateFields = {
            CRB: 'crb_expiry_date',
            'Working At Heights': 'working_at_heights',
            'Manual Handling': 'manual_handling',
            'Asbestos Cat B': 'asbestos_cat_b',
            'PPE': 'ppe'
        };
        const filteredSettings = settings.filter(i => !!i.config && Object.keys(dateFields).includes(i.name));
        const renderCard = () => (
            <Card title={title()}>
                {showAlert && errorStr ? (
                    <Alert message={errorStr} type="error" closable style={{marginBottom: 20}}/>
                ) : (showAlert ? (
                    <Alert message="Successfully updated" type="success" closable style={{marginBottom: 20}}/>
                ) : null)}

                <Row>
                    <Col md={{span: 12}}><p>Name</p></Col>
                    <Col md={{span: 12}}>{textField('full_name')}</Col>
                </Row>
                <Row>
                    <Col md={{span: 12}}><p>Job Title</p></Col>
                    <Col md={{span: 12}}>{textField('job_title')}</Col>
                </Row>
                {branches ? (
                    <Row>
                        <Col md={{span: 12}}><p>Branch Location</p></Col>
                        <Col md={{span: 12}}>{selectField('branch_location')}</Col>
                    </Row>
                ) : null}
                <Row>
                    <Col md={{span: 12}}><p>Email</p></Col>
                    <Col md={{span: 12}}>{textField('email')}</Col>
                </Row>
                <Row>
                    <Col md={{span: 12}}><p>Telephone No</p></Col>
                    <Col md={{span: 12}}>{textField('phone_number')}</Col>
                </Row>
                {Object.keys(dateFields).map(label => {
                    return required(label) ? (
                        <Row key={label}>
                            <Col md={{span: 12}}><p>{label}</p></Col>
                            <Col md={{span: 12}}>{datePicker(dateFields[label])}</Col>
                        </Row>
                    ) : null
                })}
                {this.state.edit ? (
                    <div>
                        <Button onClick={toggleEdit} style={{marginRight: 10}}>Cancel</Button>
                        <Button type='primary' htmlType="submit">Update</Button>
                    </div>
                ) : ''}

                <Collapse bordered={false} accordion>
                    <Panel header="Notes" key="2">
                    </Panel>
                    <Panel header="Documents" key="3">
                        <Document documents={documents} onUpload={onUpload} onRemove={onDelete} settings={filteredSettings} generateUrl={generateUrl}/>
                    </Panel>
                </Collapse>

                <Divider>Preferences</Divider>
                <Row>
                    {filteredSettings.map(({name = '', id = '', config = null}) => (
                        <Tag color={color(dateFields[name])} key={id} style={{marginBottom: 5}}>{name}</Tag>
                    ))}
                </Row>
            </Card>
        );
        return (
            <Form onSubmit={this.handleSubmit.bind(this)} id="landlord-edit-form">
                {renderCard()}
            </Form>
        );
    }
}
export default Form.create()(EngineerForm);


// WEBPACK FOOTER //
// ./resources/assets/js/components/shared/NonEngineer.js